/**
 * Name: 统计代码配置：cid、bid，天网错误码映射等
 */

// 页面cid配置
export const pageCids = {
  // index: 'c_pay_oneclick_index',
  guidePage: 'c_pay_oneclick_guide',
  order: 'c_pay_oneclick_order',
  retain: 'c_pay_kcdcpyow',
  introduction: 'c_pay_oneclick_introduction',
  guide: 'c_pay_oneclick_index',
  index: 'c_pay_bzvqk5wt',
  quota: 'c_pay_67xiasfu',
  halfPage: 'c_pay_2l5zrxo2', // 开通半页
  accountSetting: 'c_pay_9gjx0ze1', // 账户设置页
  closeReason: 'c_pay_nouuqckr', // 关闭原因页
};

// 页面 bid 配置
export const pageBids = {
  openBtn: 'b_pay_oneclick_click_open_mc',
  openSuccess: 'b_pay_oneclick_open_success_mv',
  openScene: 'b_pay_oneclick_open_scene_mv',
  openBindCard: 'b_pay_oneclick_bind_card_mc',
  openPassword: 'b_pay_oneclick_password_mc',
  closeOneclickBtn: 'b_pay_oneclick_close_mc',
  closeOneclickSuccess: 'b_pay_oneclick_close_success_mv',
  saveOneclickOrder: 'b_pay_oneclick_save_order_mv',
  clickOrderTypeCheckbox: 'b_pay_1jkvv54c_mc',
  showMaidanEntry: 'b_pay_x2l69sml_mv',
  clickMaidanEntry: 'b_pay_x2l69sml_mc',
  clickBindcardEntry: 'b_pay_u5252owx_mc',

  clickPersuadeQuestion: 'b_pay_36s7doz1_mc',
  clickKeepOnUseBtn: 'b_pay_z5oxrd1f_mc',
  clickStillCloseBtn: 'b_pay_arv0uug5_mc',

  showInsuranceEntry: 'b_pay_hh3bnk5f_mv',
  showCloseModal: 'b_pay_lu7lui0c_mv',
  clickModalCloseBtn: 'b_pay_qgddutx3_mc',
  clickModalReturnBtn: 'b_pay_6d0enbk9_mc',

  showDataCleanModal: 'b_pay_cock89jg_mv', // 数据清洗弹窗
  clickSetUpBtn: 'b_pay_vuf29k5z_mc',

  showOverLay: 'b_pay_b0of533l_mv', // 展示引导蒙层
  clickOverLay: 'b_pay_b0of533l_mc', // 展示引导蒙层

  // 引导页
  guideWhatIsBlock: 'b_pay_wvay87da_mv',
  guideHowToUseBlock: 'b_pay_u8xla4w0_mv',
  faqBlock: 'b_pay_k07dwmbc_mv',
  faqClick: 'b_pay_k07dwmbc_mc',
  openSuccessModal: 'b_pay_tq03k6t3_mv',
  closeOpenSuccessModal: 'b_pay_4ffk1mwz_mc',
  clickOpenSuccessModal: 'b_pay_f4oayge4_mc',
  // 详情页
  openQuotaPage: 'b_pay_qn3p9jbf_mc',
  openDeductionOrder: 'b_pay_oneclick_open_order_mc',
  clickInsuranceEntry: 'b_pay_hh3bnk5f_mc',
  homeUsageBlock: 'b_pay_4ac22s6r_mv',
  homeHowToUseEntry: 'b_pay_yj1kfy7o_mc',
  homeCloseBtnBlock: 'b_pay_rdxcvh9d_mv',
  homeCloseBtnClick: 'b_pay_rdxcvh9d_mc',
  homeAccountSettingClick: 'b_pay_kh8ro610_mc', // 已开通账号设置页
  // 额度设置
  quotaClick: 'b_pay_mu3gh77b_mc',
  quotaSwitchSuccess: 'b_pay_71kusp1p_sc',

  // 半页
  halfDeductionOrderClick: 'b_pay_f2j6e1ny_mc',
  halfOpenClick: 'b_pay_yzsx9pmn_mc',
  halfCloseClick: 'b_pay_a9zskstj_mc',

  // 账号设置页
  accountSettingCloseClick: 'b_pay_uor1ynms_mc',

  // 关闭原因页
  reasonJumpAndClick: 'b_pay_v4sn9tnk_mc',
  reasonSubmitClick: 'b_pay_05uyl807_mc',

  // 极速支付管理入口模块曝光
  manageEntryMV: 'b_pay_mo8z3kd2_mv',

  // 极速支付-已开通页-通知栏
  noticAreaClick: 'b_pay_c0euuo3m_mc',
  noticAreaView: 'b_pay_c0euuo3m_mv',

  // 优先扣款方式
  priorityHalfPageOpenClick: 'b_pay_jrshu18j_mc',
  priorityHalfPageView: 'b_pay_vnf2h2ov_mv',
  priorityHalfPageCloseClick: 'b_pay_770fkgwn_mc',
  priorityHalfPagPayTypeSelect: 'b_pay_r8cwx2sk_mc',
  // 规则说明弹窗
  ruleExplainMV: 'b_pay_00t9kjpw_mv',
  ruleExplainCloseClick: 'b_pay_3mj7zw8a_mc',
  // 优惠优先说明弹窗
  discountExplainMV: 'b_pay_7r31z06t_mv',
  discountExplainCloseClick: 'b_pay_2qzzvba7_mc',
};

export const metricPoints = {
  guidePage: 'guidePage',
  initGuideIndexPage: 'initGuideIndexPage',
  openOneclickPaySuccess: 'openOneclickPaySuccess',
  initIndexPage: 'initIndexPage',
  closeOneclickSuccess: 'closeOneclickSuccess',
  initCloseRetainPage: 'initCloseRetainPage',
  initOrderPage: 'initOrderPage',
  verifyCount: 'verifyCount',
};
